<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Trip History</strong>
           
          </div>
            <b-row>
              <b-col sm="4">
                  <b-col sm="12">
                    <b-form-group label="From Date:"  :label-cols="4" >
                    <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                    </v-date-picker>
                    </b-form-group>
                  </b-col>
              </b-col>

              <b-col sm="4">
                <b-form-group label="To Date:"  :label-cols="4" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

              <b-col v-if="usertype==1">
                <b-form-group label="Hub Name:"  :label-cols="4" >
                  <v-select v-model="selected_Hub" @input="selectsearchhub(selected_Hub)" :options="hubListing"
                    placeholder="-- Select Hub --"></v-select>
                </b-form-group>
              </b-col>
              <b-col :sm="usertype==1?12:4" :class="usertype==1?'text-right':''">
                  <b-button type="submit" size="md" variant="primary" @click="trip_history_Listing()"> Search</b-button>
                  &nbsp;
                  <b-button  size="md" variant="danger" @click="clearData">Clear</b-button>
              </b-col>
            </b-row>

            <b-col md="12" class="text-right mt-2">
                <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
            </b-col>

            <b-col md="12">
              <b-table show-empty responsive   :items="tripItems" :busy="isBusy"    :current-page="currentPage"  :fields="tripfields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div> 
                <template slot="action" slot-scope="row">
                  <b-button
                    size="sm"
                    @click="EwaybillList(row.item)"
                  >
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </b-button>
                </template>
                <template slot="trip_action" slot-scope="row">
                  <a :href="loadurl" target="_blank" class="ml-3">
                    <b-button variant="primary"  size="sm" @click="DownloadTripSheet(row.item)"> <i class="fa fa-download" aria-hidden="true"></i>
                    </b-button>
                  </a>
                </template>
                <template slot="numberplate_img_url" slot-scope="row">
                  <div>
                    <b-button variant="light" style="padding: 1px 6px;" :title="row.item.vehicle_no" @click="showvehicleimage(row.item)">
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>

            <b-row>
              <b-col md="6" class="my-1" v-if="totalRows>20">
                <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      class="my-0"
                    ></b-pagination>
            
              </b-col> 
            </b-row>
          
            <b-modal v-model="openmodels" hide-footer title="Eway Bill Details" size="xl">
              <div class="d-block text-center">
                <b-col md="12" class="text-right">
                <p > <b>Total Records :<span style="color:red;">{{ewaytotalRows}}</span></b> </p>
              </b-col>

                <b-table show-empty responsive   :items="ewaybillitem" :busy="isBusyeway"    :current-page="ewaycurrentPage"  :fields="ewayfields" :per-page="ewayperPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                  </div> 
                  <!-- <template slot="ewaybillpdf" slot-scope="row">
                    <div>
                    <a :href="row.item.ewaybillpdf" v-if="!row.item.wms_invoice_url" target="_blank"><b-button size="sm"> <i class="fa fa-download" aria-hidden="true"></i>
                      Download Eway Bill</b-button></a>
                      <b-button v-if="row.item.wms_invoice_url && row.item.ebn" size="sm" @click="downloadEwayBill(row.item)"> <i class="fa fa-download" aria-hidden="true"></i>
                        Download Consolidated Eway Bill</b-button>
                    </div>
                  </template> -->
                  <template slot="ewaybillpdf" slot-scope="row">
                    <a :href="`https://prod-1.e-waybill.in/api/e-waybill/print?ewaybill=${row.item.ebn}&html-detail=true`" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                  </template>
                  <template slot="ewaybill_file" slot-scope="row">
                    <!-- {{ row.item.ewaybill_file }} - {{ row.item.ebn }} -->
                    <span v-if="(row.item.ewaybill_file||row.item.taxilla_ewaybill_doc) && row.item.ebn">
                      <a :href="row.item.ewaybill_file?row.item.ewaybill_file:row.item.taxilla_ewaybill_doc" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span>
                    <!-- <span v-if="!row.item.ewaybill_file && row.item.ebn">
                      <a :href="`https://prod-1.e-waybill.in/api/e-waybill/print?ewaybill=${row.item.ebn}&html-detail=true`" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span> -->
                    <i class="fa fa-times" aria-hidden="true" v-if="!row.item.ewaybill_file && !row.item.ebn" style="color:red;font-size:x-large;"></i>
                  </template>
                  <template slot="wms_invoice_url" slot-scope="row">
                    <span v-if="row.item.wms_invoice_url" class="">
                      <!-- <i class="fa fa-check" aria-hidden="true"  style="color:green;font-size:x-large;"></i> -->
                      <a :href="row.item.wms_invoice_url" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span>
                    <i class="fa fa-times" aria-hidden="true" v-if="!row.item.wms_invoice_url" style="color:red;font-size:x-large;"></i>
                  </template>
                  <template slot="transport_doc" slot-scope="row">
                    <span v-if="row.item.transport_doc">
                      <!-- <i class="fa fa-check" aria-hidden="true"  style="color:green;font-size:x-large;"></i> -->
                      <a :href="row.item.transport_doc" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span>
                    <i class="fa fa-times" aria-hidden="true" v-if="!row.item.transport_doc" style="color:red;font-size:x-large;"></i>
                  </template>
                  <template slot="taxilla_ewaybill" slot-scope="row">
                    <span v-if="row.item.ebn">
                      <i class="fa fa-download" aria-hidden="true" title="Taxilla Eway Bill" style="color:blue;font-size:x-large;" @click="downloadDirectTaxillaEwayBill(row.item)"></i>
                    </span>
                    
                  </template>
                  
                </b-table>

                <b-row>
                <b-col md="6" class="my-1" v-if="ewaytotalRows>20">
                  <b-pagination
                        v-model="ewaycurrentPage"
                        :total-rows="ewaytotalRows"
                        :per-page="ewayperPage"
                        class="my-0"
                      ></b-pagination>
              
                </b-col> 
              </b-row>
              </div>
              <b-button class="mt-3 float-right" variant="danger" @click="hideModal">Close</b-button>
            </b-modal>

            <b-modal size="lg" v-model="vehicleimg" :title="`Vehicle No.` + ' - ' + vehicleimgitem.vehicle_no" hide-footer>
              <div id="listloader" v-if="loader">
                  <div class="listloader"></div>
              </div>
              <div class="text-center mb-3">
                <span v-if="vehicleimgitem.numberplate_img_url">
                  <img :src="vehicleimgitem.numberplate_img_url" alt="Vehicle Image" style="width: 100%;">
                </span>
                <span v-else>
                  Vehicle Image Not Found
                </span>
              </div>
            </b-modal>
        </b-card>
       </b-col>
     </b-row>
   </div>
</template>
<script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
  export default {
    data: function() {
      return {
        usertype :'',
        tripItems:[],
        isBusy:false,
        currentPage:1,
        tripfields:[
                  { key: 'tripid', label: 'Trip Id', sortable: true},
                  { key: 'vehicle_no', label: 'Vehicle No.', sortable: true},
                  { key: 'hub_title', label:'Hub Name',sortable: true},
                  { key: 'totalloads', label: 'Total Loads', sortable: true},          
                  { key: 'totalboxes', label: 'Total Boxes', sortable: true },    
                  { key: 'vehicleweightcarrying', label: 'Vehicle Capacity', sortable: true },
                  { key: 'vehiclephysicalweight', label: 'Vehicle Physical Weight', sortable: true },
                  { key: 'createddate', label: 'Created Date', sortable: true },
                  { key: 'startdate', label: 'Start Date', sortable: true },
                  { key: 'startlatlong', label: 'Start LatLong', sortable: true },
                  { key: 'numberplate_img_url', label: 'Vehicle No. Plate Image', sortable: true },
                  { key: 'tripenddate', label: 'End Date', sortable: true },
                  { key: 'endlatlong', label: 'End LatLong' },
                  { key: 'loadweight', label: 'Loads Physical Weight' },
                  { key: 'loadvolumetricweight', label: 'Loads Volumetric Weight' },
                  { key: 'action', label: 'Download Eway Bill' },
                  { key: 'trip_action', label: 'Download Trip Sheet'},
        ],
        perPage:20,
        filter:null,
        sortBy:null,
        sortDesc:false,
        sortDirection:'asc',
        bordered:true,
        totalRows:0,
        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        openmodels : false,
        ewaybillitem :[],
        ewayfields : [
          {key:'parentawb', label : 'Parent AWB'},
          {key:'ebn', label : 'EBN'},
          {key:'invoiceno', label : 'Invoice No'},
          // {key:'ewaybillpdf', label : 'Eway Bill PDF'}
          {key:'ewaybill_file', label: 'Ewaybill'},
          {key:'ewaybillpdf', label: '365 Ewaybill'},
          {key:'wms_invoice_url', label: 'WMS Invoice'},
          {key:'transport_doc', label: 'Transport Doc'},
          {key:'taxilla_ewaybill', label: 'Taxilla Ewaybill'},
         
          
        ],
        ewaytotalRows :'',
        ewayperPage:20,
        ewaycurrentPage:1,
        isBusyeway : false,
        hub_listing :[],
        hubListing :[],
        selected_Hub :'',
        loadurl:'',

        vehicleimg:false,
        vehicleimgitem:[]
      }
    },

    created: function() {
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.usertype = userInfo.user_type;
      this.hubDataList();
      this.trip_history_Listing();
    },

    methods: {
      hubDataList(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const Obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
        }
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,Obj).then((result)=>{
            
            if (result.body.returnmsg === 'Successful') {
              var hub_listing = result.body.returnvalue;
              console.log("hub_listing",hub_listing)

              for (let i = 0; i < hub_listing.length; i++) {
                var HubDetails = hub_listing[i].hubname + "-"+ hub_listing[i].hubid;
                this.hubListing.push(HubDetails)
              }
              console.log("hub listing",this.hubListing)
            }else{
              this.hubListing=[];
            }
        })
      },

      selectsearchhub(value_hub) {
        if(value_hub ==null){
          this.selected_Hub="";
          this.trip_history_Listing();
        }
      },

      trip_history_Listing(){
      this.currentPage=1;
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
          var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
          var selecthub_id = this.selected_Hub !=""?this.selected_Hub.split("-"):this.selected_Hub;
          var selecthub_idpass = selecthub_id[1]==undefined?null:selecthub_id[1]
          console.log("selecthub_id",selecthub_id[1])

          const Obj={
            fromdate:fromdate,
            todate:formatdateto,
            sysusermasterid:`${userInfo.sysusermasterid}`,
            hub_id :`${userInfo.hub_id}`,
            serviceid :selecthub_idpass,
            user_type : `${userInfo.user_type}`,
          }
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDistinctTripDetails`,Obj).then((result)=>{
              // console.log("Result",result);
              this.isBusy=false;
              if (result.body.returnmsg === 'Successful') {
                this.tripItems=result.body.returnvalue;
                this.totalRows=result.body.returnvalue.length;
              }else{
                this.tripItems=[];
                this.totalRows=0;
              }
          })
      },

      clearData(){
          this.selectDateFrom=new Date();
          this.selectDateTo=new Date();
          this.selected_Hub="";
          this.trip_history_Listing();
      },

      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");

      },

      hideModal : function(){
        this.openmodels = false;
      },

      EwaybillList : function (value) {
      console.log("value-----------------",value);
        this.ewaycurrentPage =1;
        this.ewaybillitem=[];
        this.ewaytotalRows=0;
        this.openmodels=true;
        this.isBusyeway=true;
        var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          const Obj={
            tripid :value.tripid,
            hub_id :value.hub_id
          }
          console.log("obj",Obj)
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getEwaybillListAndDownloadNew`,Obj).then((result)=>{
              console.log("Result",result);
              this.isBusyeway=false;
              if (result.body.returnmsg === 'Successful') {
                this.ewaybillitem=result.body.returnvalue;
                console.log("ewaybillitem",this.ewaybillitem)
                this.ewaytotalRows=result.body.returnvalue.length;
              }else{
                this.ewaybillitem=[];
                this.ewaytotalRows=0;
              }
          })
      },

      downloadEwayBill(data){
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadConsolidatedEwaybill`,data)
          .then(result=>{
            // console.log('result---------->',result)
            const base64String = result.data;
            const binaryString = window.atob(base64String);
            const uint8Array = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                uint8Array[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([uint8Array], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
          })
          .catch(error=>{
            console.log('error------------>',error)
            this.$fire({text:'Error In Downloading Consolidated E-way Bill!',type: "error",timer: 30000})
          })
      },
      DownloadTripSheet(value){
        this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/generateTripSummaryPdf?tripid=`+value.tripid;
      },
      showvehicleimage: function (data){
            this.vehicleimg = true;
            this.vehicleimgitem =[];
            this.vehicleimgitem = data;
        },

      downloadDirectTaxillaEwayBill(item){
        // document.getElementById("overlay").style.display = "block";
         let doc_Obj={
          ebn:`${item.ebn}`,
          awb:`${item.parentawb}`
         }
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadDirectEwayBillFromTaxilla`,doc_Obj).then((response)=>{
          // document.getElementById("overlay").style.display = "none";
         if(response.body.returnmsg =='Successful'){
          let url = response.body.returnvalue;
          window.open(url, '_blank');
          // this.dailyTrip(this.selected_status);
         }else{
          this.$fire({text:'Error In Download',type: "error",timer: 30000})
         }
                
         }).catch(err=>{
          console.error('err------------------->',err);
          this.$fire({text:'Error In Download',type: "error",timer: 30000})
          document.getElementById("overlay").style.display = "none";
         })
      }
    },
   
  };
</script>
<style>
  
</style>